/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react'
import LollipopChart from './LollipopChart'
import { LollipopState, ChannelEvent } from '../types'
import _ from 'lodash'

// Chart
const LollipopWidgetController = (
    props: LiveReactChartProps<LollipopState, FlowMessage<ChannelEvent>, DefaultChartConfigs>
): JSX.Element => {

    const chart = React.useRef<Highcharts.Chart>(null)
    const { state, width, height, widget } = props
    const { data, loading } = state

    useEffect(() => {

        if (!chart.current) return

        if (!loading && chart.current) {
            while (chart.current?.series.length > 0) {
                chart.current.series[0].remove(false)
            }
            chart.current.redraw()

            const grouped = _.groupBy(data, function (event) {
                return event.indicator
            })

            Object.keys(grouped).forEach(function (key) {
                const newSerieOptions = {
                    name: key,
                    id: key,
                    marker: {
                        symbol: grouped[key][0].symbol,
                        enabled: true,
                        radius: 3
                    },
                    color: grouped[key][0].__color,
                    data: grouped[key].map(item => ({
                        x: item.timestamp,
                        y: item.value,
                        color: item.__color
                    }))
                } as Highcharts.SeriesOptionsType

                chart.current.addSeries(newSerieOptions, false)

            })
            chart.current.redraw(false)
        }
    }, [data, loading])

    if (!data?.length) return <div />


    return <LollipopChart chart={chart} width={width} height={height} {...widget.jsonConfig} />
}

export default LollipopWidgetController
